import { render, staticRenderFns } from "./MasiveUploadDocuments.vue?vue&type=template&id=6a1fd2be"
import script from "./MasiveUploadDocuments.vue?vue&type=script&lang=js"
export * from "./MasiveUploadDocuments.vue?vue&type=script&lang=js"
import style0 from "./MasiveUploadDocuments.vue?vue&type=style&index=0&id=6a1fd2be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports